import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09b56f5d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-status" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdown_menu = _resolveComponent("dropdown-menu")!
  const _component_player_status = _resolveComponent("player-status")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_dropdown_menu, { class: "dropdown" }),
    _createVNode(_component_player_status, {
      name: _ctx.player1 ? _ctx.player1.playerId : '',
      playerId: _ctx.player1 ? _ctx.player1.playerId : '',
      score: _ctx.player1 ? _ctx.player1.score : '0',
      playTurn: _ctx.playTurn,
      "time-left": _ctx.getTimerDisplayFormat(_ctx.player1ElapsedTime),
      ball: _ctx.ballIconPath + _ctx.getBall(_ctx.player1),
      displayScore: _ctx.getDisplayScore(),
      enablePassback: _ctx.player1 ? _ctx.player1.enablePassback : false,
      gameKind: _ctx.getGameKind()
    }, null, 8, ["name", "playerId", "score", "playTurn", "time-left", "ball", "displayScore", "enablePassback", "gameKind"]),
    _createElementVNode("img", {
      src: _ctx.gameIcon,
      alt: "Game logo",
      class: "game-logo"
    }, null, 8, _hoisted_2),
    (_ctx.gameMode !== 'PRACTICE')
      ? (_openBlock(), _createBlock(_component_player_status, {
          key: 0,
          name: _ctx.player2 ? _ctx.player2.playerId : '',
          playerId: _ctx.player2 ? _ctx.player2.playerId : '',
          score: _ctx.player2 ? _ctx.player2.score : '0',
          playTurn: _ctx.playTurn,
          "time-left": _ctx.getTimerDisplayFormat(_ctx.player2ElapsedTime),
          ball: _ctx.ballIconPath + _ctx.getBall(_ctx.player2),
          displayScore: _ctx.getDisplayScore(),
          enablePassback: _ctx.player2 ? _ctx.player2.enablePassback : false,
          gameKind: _ctx.getGameKind(),
          align: _ctx.right
        }, null, 8, ["name", "playerId", "score", "playTurn", "time-left", "ball", "displayScore", "enablePassback", "gameKind", "align"]))
      : _createCommentVNode("", true),
    (_ctx.gameMode === 'PRACTICE')
      ? (_openBlock(), _createBlock(_component_player_status, {
          key: 1,
          name: 'No Player',
          playerId: 'AI',
          playTurn: _ctx.playTurn,
          "time-left": '0:00',
          ball: _ctx.ballIconPath + 'white.svg',
          gameKind: 'PRACTICE',
          align: _ctx.right
        }, null, 8, ["playTurn", "ball", "align"]))
      : _createCommentVNode("", true)
  ]))
}